"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBars = function SvgBars(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.997 8.68 8.11 10.174 8.93-10.175H9.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.462 11.573H24.49m-6.239 7.402v6.52"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.721 28.608h13.307s-2.017-2.744-6.653-2.744c-4.637 0-6.654 2.744-6.654 2.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.674 8.837a5.837 5.837 0 1 0-5.837 5.837c3.223 0 3.89-1.504 3.89-1.504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.879 5.708v2.691l-1.623 3.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.023 8.045 2.909.774 2.802-1.374"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgBars);
var _default = Memo;
exports["default"] = _default;